document.addEventListener('click', (e) => {
  if (e.id != 'main-navigation' && e.srcElement.closest('#main-navigation') == null) {
    $('#main-navigation .collapse.show').collapse('hide');
  }
});
